/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import { CALCWEIGHT, TICKET } from '@/models/GenerateCondit/Interrelated';
import { ReqCount, computeWeights } from '@/utils/query';
import { getArriveTime, getArriveTimeBatch } from '@/services/api';
import {
  getDataConcurrent_Vehicle2,
  selectCMlist,
  getData_Vehicle2,
} from '@/components/report/service';
import { mergeData, recombinationData } from '@/utils';

import { DurTimeStatus } from '@/Entity/PublicEntity';
import GenerateCondit from '@/models/GenerateCondit';
import { IntransitQuery } from '../Tables/Filter';
import Queryable from '@/Entity/Tools/Queryable';
import RouteEntity from '@/Entity/RouteEntity';
import { getToDay } from '@/utils/date';
import moment from 'moment';

const dateRange = getToDay();
export function convertToNumber(item) {
  if (Array.isArray(item)) {
    return item.map(convertToNumber); // 如果是数组，递归处理每一项
  } else if (typeof item === 'object' && item !== null) {
    return {
      ...item,
      calcWeight: parseFloat(item?.calcWeight) || 0,
      goodsVolume: parseFloat(item?.goodsVolume) || 0,
    }; // 如果是对象，转换字段为 number
  }
  return item; // 如果是其他类型，不做处理
}

export function matchAndAssignCalcWeight(item, info, index2) {
  if (info && info.data && Array.isArray(info.data)) {
    const matchedData = info.data.find((dataItem) => dataItem.taskNo === item.taskNo);
    if (matchedData) {
      item[`calcWeight${index2}`] = matchedData.calcWeight;
      item[`ticket${index2}`] = Math.abs(Number(matchedData.ticket) || 0);
    }
  }
}

export default {
  namespace: 'vehicleMonitoringNewIntransit',
  state: {
    intransitList: [], // 在途

    modalData: null, // top3弹窗行信息
    dataListTopThree: [], // top3弹窗数据列表
    topThreeWeight: [], // top3弹窗重量
    topThreeTicket: [], // top3弹窗票数
    senSiteAgg: {},
  },
  effects: {
    *getWayCarsData(_, { call, put, select }) {
      let query = yield select(({ vehicleMonitoringNew }) => {
        return {
          wayCarsItem: vehicleMonitoringNew.wayCarsItem,
          centerFilter: vehicleMonitoringNew.centerFilter,
          startDate: moment(dateRange[0]).format(vehicleMonitoringNew.defualtDateFormat),
          endDate: moment(dateRange[1]).format(vehicleMonitoringNew.defualtDateFormat),
        };
      });

      // 克隆新数组与新对象，避免直接修改 state 引用导致视图不刷新
      query.wayCarsItem = (query.wayCarsItem || []).map((item) => ({ ...item }));

      if (query.wayCarsItem.length > 0) {
        const taskNos = query.wayCarsItem.map((item) => item.taskNo);
        const filter = IntransitQuery({
          scanSiteCode: query.centerFilter?.code,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: taskNos,
        });

        const results = [];
        let topsResults = [];

        let siteCityTops = [];

        const result = yield call(getDataConcurrent_Vehicle2, filter, {}, 'druid2');
        console.log(`开始查询 车辆监控sr 在途 3300 数据...`);
        // selectCMlist 车辆监控sr 在途 3300
        const info = yield call(selectCMlist, {
          nextSiteCode: query.centerFilter?.code,
          taskNos: taskNos,
        });
        for (let i = 0; i < filter.length; i++) {
          const item = result[i];
          if (i === 2) {
            // 下一站top3数据源
            topsResults = [...item];
          } else if (i === 3) {
            siteCityTops = [...item];
          } else {
            results.push(item || []);
          }
        }

        let currentCenterName = query.centerFilter?.name;
        if (siteCityTops.length > 0) {
          siteCityTops = siteCityTops.filter((item) => {
            const routePaths = item.routePath ? item.routePath?.split('-') : null;
            return routePaths?.lastItem === currentCenterName;
          });
        }
        const siteCityTopsDic = recombinationData(siteCityTops, 'taskNo');
        siteCityTopsDic?.forEach((item) => {
          let allCity = item.child;
          let calcWeightSum = allCity?.reduce(
            (pre, curr) => Math.abs(Number(curr?.ticket)) + Number(pre),
            0,
          );
          let destinationSiteData = recombinationData(allCity, 'destinationCity');
          destinationSiteData?.forEach((city) => {
            city.currentCityCalcWeightSum = city?.child.reduce(
              (pre, curr) => Math.abs(Number(curr?.ticket)) + pre,
              0,
            );
            city.calcWeightSum = calcWeightSum;
          });
          destinationSiteData = destinationSiteData?.sort(
            (a, b) =>
              (b?.currentCityCalcWeightSum || 0) - (a?.currentCityCalcWeightSum || 0) ||
              String(a.destinationCity).localeCompare(String(b.destinationCity)),
          );
          item.destinationSiteData = destinationSiteData;
        });

        const newsTopsResults = [];
        if (topsResults.length > 0) {
          topsResults.forEach((item) => {
            const routePaths = item.routePath ? item.routePath?.split('-') : null;
            item.routePaths = routePaths;
            if (routePaths && routePaths.length > 2) {
              // 流向至少是3个
              item.routePath = routePaths[2].replace('分拨中心', ''); // 假设routepathc中间的就是当前分拨
            } else {
              item.routePath = null;
            }
          });
          topsResults.forEach((item) => {
            if (item.routePath) {
              newsTopsResults.push(item);
            }
          });
        }
        const newsTops = recombinationData(newsTopsResults, 'taskNo'); // 吧运输凭单号相同的,分到一个数组
        newsTops.forEach((item) => {
          let arr = mergeData(item.child, 'routePath', 'calcWeight'); // top3 相同routePath的重量相加
          // 排序必须用舍入前的原始重量,否则四舍五入制造的并列会让结果依赖接口返回行序;并列时按站点名兜底
          arr.sort(
            (a, b) =>
              Math.abs(Number(b.calcWeight) || 0) - Math.abs(Number(a.calcWeight) || 0) ||
              String(a.routePath).localeCompare(String(b.routePath)),
          );
          arr.forEach((item) => (item.calcWeight = computeWeights(item.calcWeight)));
          const newArr = arr.length > 2 ? arr.slice(0, 3) : arr;
          const strs = newArr.map((item) => item.routePath);
          item.top = strs.join(',');
        });
        const _results = convertToNumber(results);
        console.log(_results);
        query.wayCarsItem.forEach((item, index) => {
          item.index = index;
          _results.forEach((item2, index2) => {
            const obj = item2.find((item3) => item.taskNo === item3.taskNo);
            item[`unloadVolume${index2}`] = obj
              ? Math.abs(Number(obj.goodsVolume || 0).toFixed(1))
              : 0;

            if (index2 == 1) {
              // 处理3300 t票的数据
              console.info('3300 t票的数据');
              console.log(item);
              console.log(item[`calcWeight${index2}`]);
              console.log(info);
              matchAndAssignCalcWeight(item, info, index2);
            } else {
              item[`ticket${index2}`] = obj ? Math.abs(Number(obj.ticket) || 0) : 0;
              item[`calcWeight${index2}`] = computeWeights(
                obj?.calcWeight,
                1,
                index2 === 0 ? true : false,
              );
            }
          });
          const obj = newsTops.find((item3) => item.taskNo === item3.taskNo);
          item.top = obj ? obj.top : '--';

          const siteCityObj = siteCityTopsDic.find((city) => city.taskNo === item.taskNo);
          // item.cityTop = siteCityObj ? siteCityObj : '--';

          item.cityTop =
            siteCityObj?.destinationSiteData
              ?.filter((_, index) => index < 3)
              ?.map(
                (item) =>
                  `${item.destinationCity} ${(
                    (item.currentCityCalcWeightSum / item.calcWeightSum) *
                    100
                  ).toFixed(0)}%`,
              )
              ?.join(', ') || '--';

          const planTime = item.planTime ? moment(item.planTime) : null;
          item.planTime2Timestamp = planTime ? planTime.valueOf() : 0;
          item.planTime2 = planTime ? planTime.format('MM/DD HH:mm') : '--';
        });
      }
      yield put({
        type: 'update',
        payload: {
          intransitList: query.wayCarsItem || [],
        },
      });
      // yield put({ type: 'getTimes' });
    },
    // 加载预计进港时间
    *getTimes(_, { call, put, select }) {
      // 在途
      const { intransitList, locationCode } = yield select(
        ({ vehicleMonitoringNewIntransit, vehicleMonitoringNew }) => {
          return {
            intransitList: vehicleMonitoringNewIntransit.intransitList,
            locationCode: vehicleMonitoringNew.centerFilter.code,
          };
        },
      );

      // 批量接口暂时不上
      const data = yield getArriveTimeBatch({
        taskNos: intransitList?.map((item) => item?.taskNo),
        locationCode,
      });

      if (data) {
        let dataMap = data?.data?.reduce((pre, curr) => {
          pre[curr.taskNo] = curr;
          return pre;
        }, {});
        // 生成新数组和新对象，保证引用变更以触发视图刷新
        const newIntransitList = intransitList?.map((item) => {
          let resultItem = dataMap[item.taskNo];
          const now = moment(resultItem?.planHeadArriveTime || item.planTime); // 预计到达
          const time = moment(item.planTime);
          const next = { ...item };

          if (now.valueOf() === time.valueOf()) {
            next.durTimeStatus = DurTimeStatus.FIDUCIAL;
            next.durTime = '准时到达';
          } else {
            const dur = now - time;
            let tempTime = moment.duration(dur);
            const _days = tempTime.days();
            const _hours = tempTime.hours();
            const _minutes = tempTime.minutes();
            const days = _days !== 0 ? Math.abs(_days) : null;
            const hours = Math.abs(_hours);
            const minutes = Math.abs(_minutes);

            let durTime;
            if (_days < 0 || _hours < 0 || _minutes < 0) {
              durTime = '提前:';
              next.durTimeStatus = DurTimeStatus.PRE;
            } else {
              next.durTimeStatus = DurTimeStatus.DELAY;
              durTime = '延误:';
            }
            durTime += `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${
              minutes ? minutes + '分' : ''
            }`;
            next.durTime = durTime;
          }

          next.planTime3Timestamp = now.valueOf();
          next.planTime3 = now.format('MM/DD HH:mm');
          return next;
        });

        yield put({ type: 'update', payload: { intransitList: newIntransitList || [] } });
        return;
      }

      yield put({ type: 'update', payload: { intransitList } });
    },
    *getNextSiteTopThree({ payload: { modalData } }, { call, put, select }) {
      let query = yield select(({ vehicleMonitoringNew }) => {
        return {
          centerFilter: vehicleMonitoringNew.centerFilter,
          startDate: moment(dateRange[0])
            .add(-3, 'days')
            .format(vehicleMonitoringNew.defualtDateFormat),
          endDate: moment(dateRange[1]).format(vehicleMonitoringNew.defualtDateFormat),
        };
      });
      yield put({ type: 'update', payload: { modalData } });
      const gc = new GenerateCondit({
        dataSource: 'actual_load_unload_result',
        dimensions: ['routePath', 'productType'],
        startDate: query.startDate,
        endDate: query.endDate,
        aggregators: [CALCWEIGHT, TICKET],
      });
      // 查询条件
      const entity = new RouteEntity({
        scanType: '分拨装车',
        nextSiteCode: query.centerFilter?.code,
        taskNo: modalData.taskNo,
      });
      const condit = gc.converCondit(entity);
      const dataSource = yield getData_Vehicle2(condit, {}, 'druid2');
      //#region 发往网点数据
      // 发网点汇总
      const senSiteAgg = { nextSite: '发往网点', productPrecise: 0, calcWeight: 0, ticket: 0 };
      const dataList = new Queryable(dataSource);
      const tabDataList = dataList.Where((item) => {
        // 筛选routePath大于等3的流向;重量票数取绝对值,截取小数
        const routePaths = item.routePath?.split('-');
        if (routePaths?.length > 2) {
          item.nextSite = routePaths[2];
          item.productPrecise = item.productType === '定时达' ? Number(item.ticket) : 0;
          return item;
        } else {
          senSiteAgg.ticket += Number(item.ticket);
          senSiteAgg.calcWeight += Number(item.calcWeight);
          if (item.productType === '定时达') senSiteAgg.productPrecise += Number(item.ticket);
        }
      });
      tabDataList.push(senSiteAgg);
      //#endregion

      // 下一站数据
      const nextSiteData = tabDataList
        .GroupByField('nextSite')
        .AggreObject(['calcWeight', 'ticket', 'productPrecise'])
        .OrderBy(
          (first, last) => Number(first.calcWeight) > Number(last.calcWeight), // 装车数据都是负数,所以降序用的 >
        )
        .map((item) => {
          item.ticket = Math.abs(Number(item.ticket));
          item.calcWeight = computeWeights(Number(item.calcWeight));
          item.productPrecise = Math.abs(Number(item.productPrecise));
          return item;
        });

      //#region  产品类型数据
      const productData = dataList
        .GroupByField('productType')
        .AggreObject(['calcWeight', 'ticket']);
      const topThreeWeight = []; // top3重量
      const topThreeTicket = []; // top3票数
      productData.forEach((item) => {
        const ticket = Math.abs(Number(item.ticket));
        const calcWeight = computeWeights(Number(item.calcWeight));
        // 重量占比饼图数据
        if (calcWeight > 0.01) {
          topThreeWeight.push({ name: item.productType, value: calcWeight });
        }
        // 票数占比饼图数据
        if (ticket > 0) {
          topThreeTicket.push({ name: item.productType, value: ticket });
        }
      });
      //#endregion

      yield put({
        type: 'update',
        payload: {
          dataListTopThree: nextSiteData,
          topThreeWeight,
          topThreeTicket,
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
